module.exports = __webpack_public_path__ + "static/media/60.9fd607bb.jpg";